import TransferItem from '@app/transfer-bundle/models/transfer-item';
import * as TransferItemsHelper from '@app/helper/transfer-items';
import {
  FREE_EXPIRY,
  FREE_EXPIRY_ON_CHANNEL,
} from '@app/transfer-bundle/config/transfer-config';

/*
 * plus == never
 * free && onChannel == 4 weeks
 * free && not on channel == 1 week
 */
const determineExpiry = (userType, onChannel) => {
  if (userType === 'plus') {
    return 'never';
  }

  if (onChannel) {
    return FREE_EXPIRY_ON_CHANNEL;
  }

  return FREE_EXPIRY;
};

export default class Transfer {
  // Constructor for the Transfer object
  constructor({
    userType = 'free',
    type = 'email',
    onChannel = false,
    accountId,
  } = {}) {
    // This resets the counter for iOS filenames
    TransferItem.resetFilenameCounter();

    this.id = false; // the public id
    this.parent_id = false; // the parent id (for forwarding)
    this.state = 'init'; // init, started, paused, aborted, finished[, downloadable, downloading]
    this.shortURL = null; // the short (or long) url

    this.setUserType(userType);
    this.type = type === 'link' ? 'link' : 'email'; // The type decides whether it is a `link` or `email` transfer.

    this.language = 'en'; // What language is this?
    this.files = []; // Contains TransferItem objects
    this.items = [];
    this.itemsTree = TransferItemsHelper.buildItemsTree();
    this.sender = ''; // Contains e-mail address
    this.message = ''; // Contains transfer message
    this.channel = null; // Contains channel name
    this.password = null; // Contains a transfer password
    this.recipients = []; // Contains recipients (e-mail addresses)
    this.domainUserId = null;
    this.uploadStartedAt = 0;

    if (accountId) {
      this.accountId = accountId;
    }

    // Determine expiry based on user type and if it is on the channel, or, not.
    this.expiry = determineExpiry(this.userType, onChannel);
  }

  setUserType(userType, expiry = false) {
    this.userType = userType;

    // We'll need to reset some things for free users.
    if (this.userType !== 'plus') {
      this.expiry = FREE_EXPIRY;
    } else if (expiry !== false) {
      this.expiry = expiry;
    }
  }
}
